import { render, staticRenderFns } from "./OpenTasksPage.vue?vue&type=template&id=c2722662"
import script from "./OpenTasksPage.vue?vue&type=script&lang=js"
export * from "./OpenTasksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports